<div #container (onClick)="onContainerClick($event)">
  <mat-select
    #select
    [panelClass]="panelClass"
    [multiple]="multiple"
    [value]="value"
    (selectionChange)="onSelectChange($event)"
    (closed)="onSelectClosed()"
    [placeholder]="placeholder"
    [required]="required"
    [disabled]="disabled"
  >
    <div class="field_search_select">
      <input
        #input
        [ngModel]="searchText | async"
        (ngModelChange)="searchText.next($event)"
        [placeholder]="'FIND' | translate"
        class="field_search_select__input"
        (keydown)="onInputKeydown($event)"
      />
      <mat-icon matSuffix class="field_search_select__icon">search-48</mat-icon>
    </div>
    <mat-option *ngIf="!multiple && emptyOptionEnabled">{{ emptyOptionText }}</mat-option>
    <mat-option
      class="field_custom_input"
      *ngIf="allowUserInput && searchText.getValue().length"
      [value]="searchText.getValue()"
    >
      {{ searchText.getValue() }}
    </mat-option>

    <mat-checkbox
      *ngIf="showAllOption"
      color="primary"
      class="all-option-check-box"
      [checked]="checkAll"
      (change)="checkAll = $event.checked"
      (click)="onSelectOptionChange(true, select)"
    >
      <span>{{ (checkAll ? 'UNCHECK_ALL' : 'ALL') | translate }}</span>
    </mat-checkbox>

    <mat-option
      *ngFor="let option of displayedItems"
      [value]="option.value"
      (click)="onSelectOptionChange(false, select)"
    >
      <mat-icon
        *ngIf="option.icon && option.class"
        [class]="option.class"
        [svgIcon]="option.icon + ''"
        style="font: message-box"
      ></mat-icon>
      <mat-icon *ngIf="option.icon && !option.class" style="font: message-box">
        {{ option.icon }}
      </mat-icon>
      {{ option.label | translate }}
    </mat-option>
  </mat-select>
</div>
